import { Text } from '@radix-ui/themes'

interface Props {
  name: string
  date: string
  url: string | null
  /** Fills its box when unset; the caller sizes the wrapper. */
  height?: number
  /** `contain` shows the whole flyer (the headliner); `cover` crops to fill (cards). */
  fit?: 'cover' | 'contain'
  /** Placeholder text size: large for the headliner, small for cards. */
  size?: 'sm' | 'lg'
}

/**
 * An event's poster, or the brand-gradient placeholder with its name and date
 * when it has none. The same placeholder the event page and EventCard draw.
 */
export default function EventPoster({ name, date, url, height, fit = 'cover', size = 'sm' }: Props) {
  if (url) {
    return (
      <img
        src={url}
        alt={name}
        loading="lazy"
        className="block h-full w-full bg-gray3"
        style={{ height, objectFit: fit }}
      />
    )
  }

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center p-4 text-center"
      style={{ height, background: 'var(--placeholder-gradient)' }}
    >
      <Text size={size === 'lg' ? '6' : '4'} weight="bold" style={{ color: 'var(--accent-contrast)' }}>
        {name}
      </Text>
      <Text
        size={size === 'lg' ? '3' : '2'}
        mt="1"
        style={{ color: 'color-mix(in srgb, var(--accent-contrast) 80%, transparent)' }}
      >
        {date}
      </Text>
    </div>
  )
}
